import React from 'react';

import actionIcon from 'images/gift/action_icon.svg';

import styles from './styles.module.scss';

const ShowRecipientCard = ({ recipient, setEditRecipientId }) => {
  return (
    <div className={styles.subscriberContainer} key={`${recipient.id}-read`}>
      <div className={styles.nameContainer} key={`${recipient.email}-read`}>
        <div className={styles.subName}>{recipient?.name || '---'}</div>
        <div className={styles.action}>
          <img
            data-test="edit-group-subscription-button"
            id={`Edit-${recipient.recipientId}`}
            src={actionIcon}
            className={styles.giftIcon}
            onClick={() => setEditRecipientId(recipient.recipientId)}
          />
        </div>
      </div>
      <div className={styles.subInfoContainer}>
        <div className={styles.subEmail}>{recipient.email}</div>
        <div className={styles.subInfo}>
          {recipient.autoRenew ? 'Auto Renew Subscription' : 'One Year Subscription'}
        </div>
      </div>
    </div>
  );
};

export default ShowRecipientCard;
